import default_image from "../assets/default_img.png";

export type CampaignItem = {
  id: number;
  title: string;
  image: string;
  offerings: React.ReactNode;
  description: React.ReactNode;
  url: string;
};

type CampaignSummaryProps = {
  items: CampaignItem[];
};

const CampaignSummary = ({ items }: CampaignSummaryProps) => {
  // Fallback handler for broken images
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = default_image;
  };

  return (
    <div className="border-b pb-7 pl-3">
      <h2 className="text-[16px] font-bold my-4">캠페인 요약</h2>
      <div className="space-y-3">
        {items.map((item, i) => {
          const isLastItem = i === items.length - 1;

          return (
            <div key={item.id} className="flex flex-col space-y-3">
              {/* Header Row: Number + Link */}
              <div className="flex justify-between items-start">
                <div className="flex items-center">
                  <div className="w-[21px] h-[21px] rounded-full bg-[#46B6D0] text-white text-[12px] flex items-center justify-center">
                    {i + 1}
                  </div>
                  <span className="text-[#46B6D0] text-[12px] pl-4 font-bold">
                    {item.title}
                  </span>
                </div>
                <a
                  href={item.url}
                  className="text-[10px] underline text-gray-800 cursor-pointer mr-2"
                >
                  추가 정보 &gt;
                </a>
              </div>

              {/* Image + Description */}
              <div
                className={`flex gap-4 pl-6 pb-1 ml-[10px] ${
                  !isLastItem ? "border-l-2 border-[#46B6D0]" : ""
                }`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  onError={handleImageError}
                  className="max-w-[111px] w-full h-[96px] object-cover rounded-md"
                />

                <div className="text-[10px] space-y-[8px]">
                  {item.offerings && (
                    <p className="text-[#FF0000]">{item.offerings}</p>
                  )}

                  <div className="text-[#747474] space-y-[2px]">
                    {item.description}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CampaignSummary;
